
























































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Icon, Dialog, Toast } from "vant";

const createAccountModule = namespace("createAccount");

@Component({
  name: "SignWrite",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component
  }
})
export default class SignWrite extends Vue {
  @createAccountModule.Mutation("SAVE_SIGNATURE_PHOTO") saveSignaturePhoto: any;

  option = {
    backgroundColor: "transparent"
  };

  isVertical = false;
  showDialog = false;
  closeDialogFlag = false;
  // isDisabled = true;
  isEmpty = true;
  bg:any = require('@/assets/images/sign-pad-bg.png'); 

  // get isDisabled() {
  //   const signatureDom: any = this.isVertical
  //     ? this.$refs.signature
  //     : this.$refs.signatureWidth;
  //   return signatureDom && signatureDom.isEmpty;
  // }

  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
  }
  
  getLang(){
	 let lang:any =  window.localStorage.getItem('localLang')
	 if(lang === 'zh-CN'){
		return this.bg = require('@/assets/images/sign-pad-bg.png'); 
	 }else if(lang === 'zh-HK'){
		return this.bg = require('@/assets/images/sign-pad-bg-hk.png'); 
	 }else{
		return this.bg = require('@/assets/images/sign-pad-bg-en.png');
	 }
	 
  }
  

  resize() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    // const $wrapper = document.getElementById("signWriteWrap");
    // const $signPad: any = document.querySelector(".sign-pad");
    // const $signPadCanvas: any = document.querySelector(".sign-pad .canvas");
    const $html: any = document.querySelector("html");
    $html.style.height = height + "px";
    if (width >= height) {
      
      this.isVertical = false;
      this.showDialog = false;
    } else {
      // 竖屏
      this.isVertical = true;
      if (!this.closeDialogFlag) {
        this.showDialog = true;
      }
      // const ratio = Math.max(window.devicePixelRatio || 1, 1);
      // $signPadCanvas.width = $signPad.offsetHeight * ratio;
      // $signPadCanvas.height = $signPad.offsetWidth * ratio;
      // $signPadCanvas.getContext("2d").scale(ratio, ratio);
      // $signPadCanvas.getContext("2d").rotate((-90 * Math.PI) / 180);
      // this.signaturePad.clear();
      // 
    }
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  handleClearSignaturePhoto() {
    const signatureDom: any = this.isVertical
      ? this.$refs.signature
      : this.$refs.signatureWidth;
    signatureDom.clear();
  }

  handleSaveSignaturePhoto() {
    const signatureDom: any = this.isVertical
      ? this.$refs.signature
      : this.$refs.signatureWidth;
    if (signatureDom.isEmpty()) {
      if (this.isVertical) {
        return Toast({
          ["message" as any]: this.$t(
            "open_account.sign_write.empty_toast_text"
          ),
          className: "vertical-toast"
        });
      } else {
        return Toast({
          ["message" as any]: this.$t(
            "open_account.sign_write.empty_toast_text"
          )
        });
      }
    }
    const png = signatureDom.save();
    // const file = this.dataURLtoFile(png, "signature");
    
    // var hideCanvasDom: any = document.querySelector(".hide-canvas");
    // var ctx = hideCanvasDom.getContext("2d");
    // var img = new Image();
    // img.src = png;
    // img.onload = function(ev) {
    //   //获取新画布的宽高中心点
    //   var width = Math.round(
    //     $(".jSignature")
    //       .css("height")
    //       .replace("px", "") / 2
    //   );
    //   var height = Math.round(
    //     $(".jSignature")
    //       .css("width")
    //       .replace("px", "") / 2
    //   );
    //   //保存canvas状态
    //   ctx.save();
    //   //把canvas的 0,0（起点位置）设置为中心点
    //   ctx.translate(width, height);
    //   //画布旋转（旋转度数需要用  度数 *Math.PI/180 来计算）
    //   ctx.rotate((-90 * Math.PI) / 180);
    //   //绘图
    //   ctx.drawImage(img, -img.width / 2, -img.height / 2);
    //   //恢复canvas状态
    //   ctx.restore();
    //   //判断是否已经签名
    //   if (!isDraw) {
    //     tanwin("您还未签名");
    //     $(".u-submit").removeAttr("disabled");
    //   } else {
    //     //获得旋转后的签名数据
    //     var _signature = document
    //       .querySelector(".hide-canvas")
    //       .toDataURL("image/png");
    //     
    //   }
    // };

    this.saveSignaturePhoto(png);
    this.$router.go(-1);
    // const params = new FormData();
    // params.append("file", file);
    // params.append("put_dir", "gygjqh_autograph");
    // (this as any).$apis
    //   .uploadFile(params)
    //   .then(res => {
    //     
    //     const { content, url } = res;
    //     this.saveSignaturePhoto(url);
    //     this.$router.go(-1);
    //     // (this as any).$apis
    //     //   .saveSignaturePhoto({
    //     //     open_type: this.$route.query.open_type || 1,
    //     //     autograph_img: content
    //     //   })
    //     //   .then(res => {
    //     //     
    //     //   })
    //     //   .catch(e => {
    //     //     
    //     //   });
    //   })
    //   .catch(e => {
    //     
    //   });
  }
}
